exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".follow-request-card-content-container{display:flex;flex-direction:row;flex-wrap:wrap}.follow-request-card-content-container button{margin-top:.5em;margin-right:.5em;flex:1 1;max-width:12em;min-width:8em}.follow-request-card-content-container button:last-child{margin-right:0}", ""]);

// exports
